import React from 'react'
import { Drawer, Tabs } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { isNumber } from 'lodash'
import rubricSelectors from '../../../../../store/selectors/rubric.selectors'
import { rubricActions } from '../../../../../store/slices/rubric.slice'
import RubricPropertiesTab from './tabs/RubricPropertiesTab'
import RubricCategoriesTab from './tabs/RubricCategoriesTab'
import { useFetchRubricsQuery } from '../../../../../store/apis/rubric.api'
import { fetchRubricsSelectors } from '../../../../../store/apis/utils/selectors/rubric.api.selectors'

const RubricDrawer = () => {
    const dispatch = useDispatch()
    const { token } = useParams()
    const editingRubricId = useSelector(rubricSelectors.editingRubricId)
    const showCreateRubricDrawer = useSelector(rubricSelectors.showCreateRubricDrawer)
    
    const isEditing = isNumber(editingRubricId)
    const isOpen = isEditing || showCreateRubricDrawer

    const { data: rubric } = useFetchRubricsQuery({ token }, {
        skip: !isEditing,
        selectFromResult: result => fetchRubricsSelectors.byId({ id: editingRubricId }, result),
    })

    const handleClose = () => {
        dispatch(rubricActions.setEditingRubricId(null))
        dispatch(rubricActions.setShowCreateRubricDrawer(false))
        dispatch(rubricActions.setEditingCategoryId(null))
        dispatch(rubricActions.setShowCreateCategoryDrawer(false))
    }

    const title = isEditing ? `Edit Rubric: ${rubric?.name || ''}` : 'Create Rubric'

    const tabItems = [
        {
            key: 'properties',
            label: 'Properties',
            children: <RubricPropertiesTab onClose={handleClose} />,
        },
    ]

    // Only show categories tab when editing an existing rubric
    if (isEditing) {
        tabItems.push({
            key: 'categories',
            label: 'Categories',
            children: <RubricCategoriesTab />,
        })
    }

    return (
        <Drawer
            title={title}
            open={isOpen}
            onClose={handleClose}
            width={640}
            destroyOnClose
        >
            <Tabs items={tabItems} defaultActiveKey='properties' />
        </Drawer>
    )
}

export default RubricDrawer
